import React from "react";
import '../../CSS/entrepreneur.css';
import Carousel from "../composant_reutilisable/Carousel";
import back_image_card_3 from '../../images/back_image_card_3.svg';
import main from '../../images/782300775268001733135693.svg';
import piece from '../../images/418020461225001733135856.svg';
import people from '../../images/908260548257001733135777.svg';
import sous from '../../images/137260876063001733136031.svg';
import { FaArrowRight } from "react-icons/fa";
import entrepreneuriat from '../../images/entrepreneuriat.png';
import BlocSection from "../composant_reutilisable/Bloc";

const Entrepreneur = () => {
    return (
        <div className="visiter-container">
            <div className="visiter-content">
                <div className="visiter-texte">
                    <div className="visiter-paragraphe">
                        <h1>Accélérer l'entrepreneuriat et<br />l'innovation 'MADE IN BENIN'</h1>
                        <p>
                            Le Bénin s'engage activement à propulser l'entrepreneuriat à <br /> travers un dispositif intégré de formation, accompagnement et <br /> financement. Trois institutions clés – ADPME, CDC Bénin et <br /> Sèmè City – facilitent le parcours des entrepreneurs, qu'ils soient sur le sol béninois ou au sein de notre diaspora.
                        </p>

                    

                            </div>
                    <div className="mt-5"  >
                       <img
                            src={entrepreneuriat}
                            alt="entrepreneuriat"
                        style={{
                            height: '350px',
                            width: 'auto',
                            
                        }}
                        />
                    </div>
                    
                    
                </div>
                

                <BlocSection />
            </div>
        </div>
    );
};

export default Entrepreneur;